import { Star } from "lucide-react";

/** Read-only star row (size via className on the wrapper). */
export function Stars({ rating, className = "" }) {
  return (
    <span
      className={`inline-flex items-center gap-0.5 ${className}`}
      aria-label={`${rating} out of 5 stars`}
      role="img"
    >
      {[1, 2, 3, 4, 5].map((n) => (
        <Star
          key={n}
          className={`h-4 w-4 ${n <= rating ? "fill-royal text-royal" : "fill-transparent text-slate-300"}`}
          aria-hidden="true"
        />
      ))}
    </span>
  );
}

/** Clickable star input used in the review form. */
export function StarInput({ value, onChange, testId }) {
  return (
    <div className="flex items-center gap-1" role="radiogroup" aria-label="Rating" data-testid={testId}>
      {[1, 2, 3, 4, 5].map((n) => (
        <button
          key={n}
          type="button"
          role="radio"
          aria-checked={value === n}
          aria-label={`${n} star${n > 1 ? "s" : ""}`}
          data-testid={`${testId}-${n}`}
          onClick={() => onChange(n)}
          className="rounded p-0.5 transition-transform hover:scale-110 focus:outline-none focus-visible:ring-2 focus-visible:ring-royal"
        >
          <Star
            className={`h-7 w-7 transition-colors ${n <= value ? "fill-royal text-royal" : "fill-transparent text-slate-300 hover:text-royal/60"}`}
            aria-hidden="true"
          />
        </button>
      ))}
      <span className="ml-2 font-mono-sub text-xs text-mute">{value ? `${value}/5` : "Select"}</span>
    </div>
  );
}
